import { defineMessages } from "react-intl";

export const giftCardTagInputMessages = defineMessages({
  placeholder: {
    id: "XFtKV5",
    defaultMessage: "Tag",
    description: "input placeholder tag",
  },
});
